export const makePrefix = (prefix, className) => `.${prefix}-${className}`
